import { useTheme, Box, Collapse, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Feedback from '../../special/Feedback';
import { tokens } from '../../../global/theme/tokens';
import NewTextBlock from './template-blocks/NewTemplateBlock';
import { ProjectAddElementButton } from '../../exo/project/ProjectAddElementButton';
import { useTranslation } from 'react-i18next';
import { TemplateBlock } from './template-blocks/TemplateBlock';
import { updateOrCreate } from '../../special/updateOrCreate';
import ExoDialog from '../../exo/ExoDialog';
import TemplateBlockEditor from './template-blocks/TemplateBlockEditor';
import { API_DELETE, DBRequest, useConfig } from '../../../api/api';

const TemplateBlocks = ({
  onSelect,
  activeType,
  templateBlocks,
  setTemplateBlocks,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();

  const { t } = useTranslation();

  const [apiData, setApiData] = useState(null);
  const [open, setOpen] = useState(false);

  const [edit, setEdit] = useState(null);
  const [codeEdit, setCodeEdit] = useState(null);

  useEffect(() => {
    if (!templateBlocks) {
      DBRequest({
        config,
        path: activeType
          ? `template-blocks?type[eq]=${activeType}`
          : 'template-blocks',
        onResponse: setApiData,
      });
    } else {
      setApiData(templateBlocks);
    }
  }, [config, templateBlocks]);

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  function handleChange(data) {
    if (!templateBlocks) {
      setApiData(updateOrCreate(apiData, data.data));
    } else {
      setTemplateBlocks(updateOrCreate(templateBlocks, data.data));
    }
    setEdit(null);
    setOpen(false);
  }

  function handleDelete(data) {
    setEdit(null);
    if (!templateBlocks) {
      setApiData({
        ...apiData,
        data: apiData?.data?.filter((obj) => obj.id !== data?.id),
      });
    } else {
      setTemplateBlocks({
        ...templateBlocks,
        data: templateBlocks?.data?.filter((obj) => obj.id !== data?.id),
      });
    }

    DBRequest({
      config,
      path: `template-blocks/${data.id}`,
      method: API_DELETE(),
      onError: () => handleChange(data),
    });

    setEdit({});
    setOpen(false);
  }

  const [startType, setStartType] = useState(null);

  useEffect(() => {
    if (activeType && !edit) {
      setStartType({ types: [activeType] });
    } else {
      if (edit) setStartType(edit);
    }
  }, [activeType, edit]);

  return (
    <Box className="flex flex-col gap-4 cursor-pointer">
      <Typography fontWeight={600} className="opacity-50">
        {t('Smart Template Blocks')}
      </Typography>
      <Box className="flex flex-col max-w-[500px] w-full">
        <Collapse limitWidth in={open}>
          <NewTextBlock
            startData={startType}
            onFeedback={handleFeedback}
            onCreate={handleChange}
            onClose={() => {
              setEdit(null);
              setOpen(false);
            }}
            onDelete={handleDelete}
          />
        </Collapse>
        <Collapse in={!open}>
          <ProjectAddElementButton
            label={t('Add')}
            size="small"
            onClick={() => setOpen(true)}
          />
        </Collapse>
      </Box>

      {apiData?.data?.map((block) => (
        <TemplateBlock
          key={block.id}
          data={block}
          onEdit={(e) => {
            setOpen(true);
            setEdit(e);
          }}
          onSelect={onSelect}
          onCodeEdit={(e) => setCodeEdit(e)}
        />
      ))}
      <ExoDialog
        open={Boolean(codeEdit)}
        onClose={() => setCodeEdit(null)}
        noBlur
      >
        <TemplateBlockEditor
          data={codeEdit}
          onSave={handleChange}
          onFeedback={handleFeedback}
          onClose={() => setCodeEdit(null)}
        />
      </ExoDialog>
      <Feedback setState={setAlertState} state={alertState} />
    </Box>
  );
};

export default TemplateBlocks;
